module.exports = __webpack_public_path__ + "static/WS_Cuenca_header_tarjetas_desktop-c781fc59027cf939eac80e449bd84af6.png";